import { useAlertUiTranslation } from '../../../../../hooks';
import { useDetailsPanel } from './Panels/useDetailsPanel';
import { useMessagesPanel } from './Panels/useMessagesPanel';
export function useAddMessageStep() {
    const { t } = useAlertUiTranslation();
    return {
        label: t('wizard.addMessage.addMessage'),
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    key: 'content1',
                    style: {
                        paddingTop: 8,
                    },
                    html: `<h3>${t('wizard.addMessage.addMessage')}</h3>`,
                },
                useDetailsPanel({ mode: 'edit', paddingTop: 36 }),
                ...useMessagesPanel({ mode: 'edit' }),
            ],
        },
    };
}
